"use client";

import { FileType, Media, TranscriptEnum } from "@knowt/syncing/graphql/schema";
import { useMedia } from "@knowt/syncing/hooks/media/useMedia";

import PDFViewer from "./PDFViewer";
import AudioPlayer from "./AudioPlayer";
import VideoPlayer from "./VideoPlayer";
import { MediaViewerWithTranscripts } from "./MediaViewerWithTranscripts";
import { EmbeddedMediaPlayer } from "./EmbeddedMediaPlayer";

const MediaViewer = ({
    media: initialMedia,
    transcriptContainerStyle,
}: {
    media: Media;
    transcriptContainerStyle?: React.CSSProperties;
}) => {
    const { media, mediaUrl, chaptersUrl, spriteSheetUrl, subtitlesUrl, utterances, transcript } = useMedia({
        mediaId: initialMedia.mediaId,
        fallbackData: initialMedia,
    });

    if (!media) return null;

    if (media.type === "PDF") return <PDFViewer documentId={media.mediaId} jwt={media.jwt} />;

    if (media.type === "VIDEO") {
        if (media.fileType === FileType.MP3 || media.fileType === FileType.M4A || media.fileType === FileType.WAV) {
            return (
                <MediaViewerWithTranscripts
                    transcript={transcript}
                    utterances={utterances}
                    transcriptType={media.transcript || TranscriptEnum.NONE}
                    containerStyle={transcriptContainerStyle}>
                    <AudioPlayer src={mediaUrl} chaptersUrl={chaptersUrl} />
                </MediaViewerWithTranscripts>
            );
        }

        if (media.embedUrl) {
            return (
                <MediaViewerWithTranscripts
                    transcript={transcript}
                    utterances={utterances}
                    transcriptType={media.transcript || TranscriptEnum.NONE}
                    containerStyle={transcriptContainerStyle}>
                    <EmbeddedMediaPlayer media={media} />
                </MediaViewerWithTranscripts>
            );
        }

        return (
            <MediaViewerWithTranscripts
                transcript={transcript}
                utterances={utterances}
                transcriptType={media.transcript || TranscriptEnum.NONE}
                containerStyle={transcriptContainerStyle}>
                <VideoPlayer
                    src={mediaUrl}
                    spriteSheetUrl={spriteSheetUrl}
                    subtitlesUrl={subtitlesUrl}
                    chaptersUrl={chaptersUrl}
                />
            </MediaViewerWithTranscripts>
        );
    }

    return <div data-testid="auto-id-bb32e80f-411d-496e-9b53-5279b83daef9">Unsupported media type: {media.type}</div>;
};

export default MediaViewer;
